<template>
  <div class="diy-card-catalogue__card">
    <ExpansionPanel :transition-duration="500" :expanded="false">
      <!-- HEADER -->
      <template #panel-header="{ toggleTransitionCollapse }">
        <div class="diy-card-catalogue__card-heading">
          <!-- arrow -->
          <div class="diy-card-catalogue__card-arrow">
            <AppIcon icon="far fa-angle-right" />
          </div>
          <!-- title -->
          <div
            class="diy-card-catalogue__card-title"
            @click="shortDescription && toggleTransitionCollapse()"
          >
            <AppHeading tag="h3" :text="card.title" />
          </div>
          <!-- actions -->
          <CardCatalogueCardActions v-if="!isMobile" :card="card" />
        </div>
      </template>
      <!-- BODY -->
      <template #panel-body>
        <div v-if="shortDescription" class="diy-card-catalogue__card-body">
          <MarkdownText :text="shortDescription" />
          <!-- external action link -->
          <AppLink v-if="card.hs_slug" external :href="cardURL" :text="$t('ui.buttons.more_info')">
            <AppIcon icon="far fa-external-link" />
          </AppLink>
        </div>
      </template>
      <!-- actions -->
      <template v-if="isMobile" #panel-footer>
        <CardCatalogueCardActions :card="card" />
      </template>
    </ExpansionPanel>
  </div>
</template>

<script>
// Utilities
import { actionURLBase } from 'Utils/config/diy'
import MobileBreakpointControl from 'Mixins/MobileBreakpointControl'
// Components
import AppIcon from 'Ui/AppIcon'
import AppLink from 'Ui/AppLink'
import AppHeading from 'Ui/AppHeading'
import ExpansionPanel from 'Components/ExpansionPanel'
import CardCatalogueCardActions from './CardCatalogueCardActions'
import MarkdownText from 'Modules/Markdown/components/MarkdownText'

export default {
  name: 'CardCatalogueCard',

  components: {
    AppIcon,
    AppLink,
    AppHeading,
    MarkdownText,
    ExpansionPanel,
    CardCatalogueCardActions,
  },

  props: {
    card: {
      type: Object,
      required: true,
    },
  },

  mixins: [MobileBreakpointControl],

  computed: {
    cardURL() {
      return actionURLBase + this.card.hs_slug
    },

    shortDescription() {
      return this.card.short_description
    },
  },

  // created() {
  //   console.log(this.card)
  // },
}
</script>

<style scoped>
.diy-card-catalogue__card {
  display: grid;
  align-items: center;
  border-radius: 6px;
  padding: 10px;
  background: var(--c-secondary-300);
}

.diy-card-catalogue__card-heading {
  display: grid;
  grid-template-columns: 25px 1fr auto;
  align-items: center;
  position: relative;
  user-select: none;
}

.diy-card-catalogue__card-arrow {
  display: flex;
  align-items: center;
  position: relative;
  height: 100%;
}

.diy-card-catalogue__card-arrow >>> .app-icon {
  position: absolute;
  font-weight: 300;
  font-size: 20px;
  left: 10px;
  line-height: 100%;
  color: var(--c-secondary);
  transform-origin: center;
  backface-visibility: hidden;
  transition: var(--transition--default);
}

.expanded .diy-card-catalogue__card-arrow >>> .app-icon {
  transform: rotate(90deg);
}

.diy-card-catalogue__card-title .app-heading {
  font-size: 18px;
  font-weight: 700;
  width: 100%;
  cursor: pointer;
}

.diy-card-catalogue__card-body {
  padding-left: 20px;
}

.diy-card-catalogue__card-body >>> .app-link {
  display: inline-block;
  margin-top: 10px;
  padding: 0;
}

.diy-card-catalogue__card-body >>> .app-link:hover .app-link__text {
  text-decoration: underline;
}

.diy-card-catalogue__card-body >>> .markdown__marked-text {
  width: 100%;
  padding: 0;
}

.diy-card-catalogue__card-body >>> .markdown__marked-text * {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  color: var(--c-secondary);
}

/* Responsive --------- */
@media (max-width: 680px) {
  .diy-card-catalogue__card-heading {
    grid-template-columns: 25px 1fr;
    row-gap: 10px;
  }

  .diy-card-catalogue__card-actions {
    margin-top: 20px;
  }
}
</style>
